import React from "react";
import "./mspsettingsv2.scss"
import { Row } from "react-bootstrap";
import SettingsPageBlockItem from "./SettingsPageBlockItem";

const SettingsPageBlock = ({
  header = '',
  data = [],
}) => {
  return (
    <div className="personal-info">
      <h4>{header}</h4>
      <div className="user-details">
        <Row>
          {
            data?.map((dataItem, index) => {
              return (
                <SettingsPageBlockItem
                  label={dataItem?.label}
                  value={dataItem.value}
                  show={dataItem?.show}
                  bottomBorder={dataItem?.show ? index < data.filter(item => item.show).length - 1 : false}
                  children={dataItem?.children}
                  itemStyle={dataItem?.itemStyle}
                  labelStyle={dataItem?.labelStyle}
                  description={dataItem?.description}
                  onClick={dataItem.onClick}
                />
              )
            })
          }
        </Row>
      </div>
    </div>
  );
};

export default SettingsPageBlock;
